// extracted by mini-css-extract-plugin
export default {"page":"FY-z","cartModal":"GY-z","checkout":"HY-z","placeholder":"IY-z","account":"JY-z"};